import { PrimeIcons } from 'primeng/api';

export const TRIGGER_EVENT = {
  LEAD_CREATED: 'LEAD_CREATED',
  VOUCHER_UPLOADED: 'VOUCHER_UPLOADED',
  RETRAINING_CONTRACT_UPLOADED: 'RETRAINING_CONTRACT_UPLOADED',
  COURSE_STARTS: 'COURSE_STARTS',
  COURSE_STARTS_IN_ONE_WEEK: 'COURSE_STARTS_IN_ONE_WEEK',
  EXAM_IS_TODAY: 'EXAM_IS_TODAY',
  EXAM_IN_SIX_WEEKS: 'EXAM_IN_SIX_WEEKS',
  EXAM_REGISTRATION_DEADLINE_IN_SIX_WEEKS:
    'EXAM_REGISTRATION_DEADLINE_IN_SIX_WEEKS',
  MONTH_STARTS_COURSE_RUNNING: 'MONTH_STARTS_COURSE_RUNNING',
  DOCENT_TEACHES_THIS_MONTH: 'DOCENT_TEACHES_THIS_MONTH',
  BIRTHDAY_IN_ONE_WEEK: 'BIRTHDAY_IN_ONE_WEEK',
} as const;

export const TRIGGER_EVENTS = [
  {
    label: 'Lead wurde angelegt',
    value: TRIGGER_EVENT.LEAD_CREATED,
    tooltip:
      'Wenn ein neuer Lead angelegt wird, werden die unten spezifizierten ToDos erzeugt, mit Bezugnahme auf den neuen Lead',
  },
  {
    label: 'Bildungsgutschein wurde zugewiesen',
    value: TRIGGER_EVENT.VOUCHER_UPLOADED,
    tooltip:
      'Wenn ein Bildungsgutschein hochgeladen wird, werden die unten spezifizierten ToDos erzeugt, mit Bezugnahme auf den dazugehörigen Lead/TN',
  },
  {
    label: 'Umschulungsvertrag wurde hochgeladen',
    value: TRIGGER_EVENT.RETRAINING_CONTRACT_UPLOADED,
    tooltip:
      'Wenn ein Umschulungsvertrag hochgeladen wird, werden die unten spezifizierten ToDos erzeugt, mit Bezugnahme auf den dazugehörigen Lead/TN',
  },
  {
    label: 'Kurs beginnt und TN ist Kurs zugeordnet',
    value: TRIGGER_EVENT.COURSE_STARTS,
    tooltip:
      'Die unten spezifizierten ToDos werden JE EINMAL für alle dem Kurs zugeordneten TN erzeugt, wenn dieser startet',
  },
  {
    label: 'Kurs beginnt in 1 Woche und TN ist Kurs zugeordnet',
    value: TRIGGER_EVENT.COURSE_STARTS_IN_ONE_WEEK,
    tooltip:
      'Die unten spezifizierten ToDos werden JE EINMAL für alle dem Kurs zugeordneten TN erzeugt, eine Woche bevor dieser startet',
  },
  {
    label: 'Prüfung ist heute und TN ist Kurs zugeordnet',
    value: TRIGGER_EVENT.EXAM_IS_TODAY,
    tooltip:
      'Am Tag einer Prüfung werden die unten spezifizierten ToDos JE EINMAL für alle TN erzeugt, für die diese Prüfung gilt',
  },
  {
    label: 'Prüfung ist in 6 Wochen und TN ist Kurs zugeordnet',
    value: TRIGGER_EVENT.EXAM_IN_SIX_WEEKS,
    tooltip:
      '6 Wochen vor einer Prüfung werden die unten spezifizierten ToDos JE EINMAL für alle TN erzeugt, für die diese Prüfung gilt',
  },
  {
    label:
      'Anmeldefrist für Prüfung ist in 6 Wochen und TN ist Kurs zugeordnet',
    value: TRIGGER_EVENT.EXAM_REGISTRATION_DEADLINE_IN_SIX_WEEKS,
    tooltip:
      'Etwa 6 Wochen vor der Anmeldefrist für eine Prüfung werden die unten spezifizierten ToDos JE EINMAL für alle TN erzeugt, für die diese Prüfung gilt',
  },
  {
    label: 'Anfang des Monats und Kurs läuft',
    value: TRIGGER_EVENT.MONTH_STARTS_COURSE_RUNNING,
    tooltip:
      'Die unten spezifizierten ToDos werden am 01. jeden Monats EINMAL PRO laufendem Kurs erzeugt',
  },
  {
    label: 'Kurs läuft und Dozent unterrichtet diesen Monat',
    value: TRIGGER_EVENT.DOCENT_TEACHES_THIS_MONTH,
    tooltip:
      'Jeden Tag wird geprüft, ob ein Dozent diesen Monat einen Kurs unterrichtet. Falls ja, werden die unten spezifizierten ToDos für diesen Dozenten erzeugt.',
  },
  {
    label: 'Geburtstag von TN in einer Woche',
    value: TRIGGER_EVENT.BIRTHDAY_IN_ONE_WEEK,
    tooltip:
      'Wenn ein Geburtstag von TN in einer Woche passiert wird, werden die unten spezifizierten ToDos erzeugt, mit Bezugnahme auf den TN',
  },
];

export const COMPLETION_EVENT = {
  LEAD_CONVERTED: 'LEAD_CONVERTED',
  DOCUMENT_MARKED_PRESENT: 'DOCUMENT_MARKED_PRESENT',

  VOUCHER_UPLOADED: 'VOUCHER_UPLOADED',
  IHK_REGISTRATION_UPLOADED: 'IHK_REGISTRATION_UPLOADED',
  EDUCATION_PROVIDER_CONFIRMATION_UPLOADED:
    'EDUCATION_PROVIDER_CONFIRMATION_UPLOADED',
  INTERNSHIP_CONTRACT_UPLOADED: 'INTERNSHIP_CONTRACT_UPLOADED',
  RETRAINING_CONTRACT_UPLOADED: 'RETRAINING_CONTRACT_UPLOADED',
  PRIVACY_POLICY_UPLOADED: 'PRIVACY_POLICY_UPLOADED',
  SHIPPING_CONFIRMATION_UPLOADED: 'SHIPPING_CONFIRMATION_UPLOADED',
  CONVERSATION_PROTOCOL_UPLOADED: 'CONVERSATION_PROTOCOL_UPLOADED',
  EXAM_INVITATION_UPLOADED: 'EXAM_INVITATION_UPLOADED',
  EXAM_REGISTRATION_UPLOADED: 'EXAM_REGISTRATION_UPLOADED',

  APTITUDE_TEST_RESULT_SENT: 'APTITUDE_TEST_RESULT_SENT',

  EXAM_RESULT_REGISTERED: 'EXAM_RESULT_REGISTERED',

  FEEDBACK_CREATED: 'FEEDBACK_CREATED',

  NONE: 'NONE',
} as const;

export const COMPLETION_EVENTS = [
  {
    label: 'Aus Lead wird Teilnehmer (oder Lead erledigt)',
    value: COMPLETION_EVENT.LEAD_CONVERTED,
    tooltip:
      'Das ToDo ist abgeschlossen, wenn die Stammdaten des Lead bearbeitet werden und ENTWEDER die Rolle "Teilnehmer" zugewiesen wird ODER "Ist aktiv?" deaktiviert wird.',
  },
  {
    label: 'Dokument wird als vorhanden markiert',
    value: COMPLETION_EVENT.DOCUMENT_MARKED_PRESENT,
    tooltip:
      'Durch den korrekten Upload wird das ToDo automatisch abgeschlossen. Eine Markierung ist nicht vorgesehen.',
  },
  {
    label: 'Bildungsgutschein wird hochgeladen',
    value: COMPLETION_EVENT.VOUCHER_UPLOADED,
    tooltip:
      'Das ToDo wird automatisch abgeschlossen, wenn ein Bildungsgutschein für diesen Lead hochgeladen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'IHK Anmeldung wird hochgeladen',
    value: COMPLETION_EVENT.IHK_REGISTRATION_UPLOADED,
    tooltip:
      'Das ToDo wird automatisch abgeschlossen, wenn eine IHK-Anmeldung für diesen Lead hochgeladen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Praktikumsvertrag wird hochgeladen',
    value: COMPLETION_EVENT.INTERNSHIP_CONTRACT_UPLOADED,
    tooltip:
      'Das ToDo wird automatisch abgeschlossen, wenn ein Praktikumsvertrag für diesen Lead hochgeladen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Umschulungsvertrag wird hochgeladen',
    value: COMPLETION_EVENT.RETRAINING_CONTRACT_UPLOADED,
    tooltip:
      'Das ToDo wird automatisch abgeschlossen, wenn ein Umschulungsvertrag für diesen Lead hochgeladen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Datenschutzerklärung wird hochgeladen',
    value: COMPLETION_EVENT.PRIVACY_POLICY_UPLOADED,
    tooltip:
      'Das ToDo wird automatisch abgeschlossen, wenn eine Datenschutzerklärung für diesen Teilnehmer hochgeladen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Versandbestätigung wird hochgeladen',
    value: COMPLETION_EVENT.SHIPPING_CONFIRMATION_UPLOADED,
    tooltip:
      'Das ToDo wird automatisch abgeschlossen, wenn eine Versandbestätigung für diesen Teilnehmer hochgeladen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Gesprächsprotokoll wird hochgeladen',
    value: COMPLETION_EVENT.CONVERSATION_PROTOCOL_UPLOADED,
    tooltip:
      'Das ToDo wird automatisch abgeschlossen, wenn ein Gesprächsprotokoll für diesen Teilnehmer hochgeladen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Bestätigung des Bildungsträgers wird hochgeladen',
    value: COMPLETION_EVENT.EDUCATION_PROVIDER_CONFIRMATION_UPLOADED,
    tooltip:
      'Das ToDo ist abgeschlossen, wenn über die Aktivitäten eine Bestätigung für diesen Lead hochgeladen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Eignungstest Ergebnis wird versendet',
    value: COMPLETION_EVENT.APTITUDE_TEST_RESULT_SENT,
    tooltip:
      'Das ToDo wird automatisch abgeschlossen, wenn ein Eignungstest für diesen Lead durchgeführt wird. Er wird versendet und hochgeladen. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Prüfungsergebnis wird eingetragen',
    value: COMPLETION_EVENT.EXAM_RESULT_REGISTERED,
    tooltip:
      'Das ToDo ist abgeschlossen, wenn die entsprechende Note für diesen Lead eingetragen wird. Sollte das schon erledigt sein, setzen Sie den Status bitte manuell auf "Abgeschlossen".',
  },
  {
    label: 'Prüfungseinladung wird hochgeladen',
    value: COMPLETION_EVENT.EXAM_INVITATION_UPLOADED,
    tooltip:
      'Das ToDo ist abgeschlossen, wenn die Einladung hochgeladen wurde.',
  },
  {
    label: 'Prüfungsanmeldung wird hochgeladen',
    value: COMPLETION_EVENT.EXAM_REGISTRATION_UPLOADED,
    tooltip:
      'Das ToDo ist abgeschlossen, wenn die seitens des Teilnehmers unterschriebene Prufungsanmeldung an IHK verschickt und hier hochgeladen wurde.',
  },
  {
    label: 'Manuelles Abschließen',
    value: COMPLETION_EVENT.NONE,
    tooltip: 'Schließen Sie das ToDo ab, indem Sie manuell den Status ändern.',
  },
  {
    label: 'Feedback erstellt',
    value: COMPLETION_EVENT.FEEDBACK_CREATED,
    tooltip:
      'Das ToDo ist abgeschlossen, wenn ein Feedback für diesen Kurs und Monat erstellt wurde.',
  },
];

export const TODO_STATUS = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  CANCELLED: 'CANCELLED',
} as const;

export const TODO_STATUSES = [
  { label: 'Offen', value: TODO_STATUS.OPEN, class: 'state-label open' },
  {
    label: 'In Bearbeitung',
    value: TODO_STATUS.IN_PROGRESS,
    class: 'state-label in-progress',
  },
  {
    label: 'Abgeschlossen',
    value: TODO_STATUS.DONE,
    class: 'state-label done',
  },
  {
    label: 'Abgebrochen',
    value: TODO_STATUS.CANCELLED,
    class: 'state-label cancelled',
  },
];

export const TODO_STATUS_ICON_MAP: Record<
  string,
  { icon: string; color: string; label: string }
> = {
  [TODO_STATUS.OPEN]:        { icon: 'pi pi-circle',       color: 'var(--primary-color)',    label: 'Offen' },
  [TODO_STATUS.IN_PROGRESS]: { icon: 'pi pi-sync',         color: 'var(--blue)',             label: 'In Bearbeitung' },
  [TODO_STATUS.DONE]:        { icon: 'pi pi-check-circle', color: 'var(--green)',            label: 'Abgeschlossen' },
  [TODO_STATUS.CANCELLED]:   { icon: 'pi pi-times-circle', color: 'var(--secondary-color)',  label: 'Abgebrochen' },
};

export const ENTITY_TYPE = {
  UNDEFINED: 'UNDEFINED',
  USER: 'USER',
  COURSE: 'COURSE',
  PERSONAL_USER: 'PERSONAL_USER',
} as const;

export const ENTITY_TYPES = [
  {
    label: 'Unbestimmt',
    value: ENTITY_TYPE.UNDEFINED,
    icon: PrimeIcons.QUESTION_CIRCLE,
  },
  { label: 'Benutzer', value: ENTITY_TYPE.USER, icon: PrimeIcons.USER },

  { label: 'Kurs', value: ENTITY_TYPE.COURSE, icon: PrimeIcons.BOOK },
  {
    label: 'Persönlich',
    value: ENTITY_TYPE.PERSONAL_USER,
    icon: PrimeIcons.TAG,
  },
];

export const SCHEDULE_TYPE = {
  IMMEDIATE: 'IMMEDIATE',
  DELAYED: 'DELAYED',
  SCHEDULED: 'SCHEDULED',
  INTERVAL: 'INTERVAL',
} as const;

export const SCHEDULE_TYPES = [
  {
    label: 'Sofort',
    value: SCHEDULE_TYPE.IMMEDIATE,
    tooltip: 'Sobald das Triggerereignis eintritt, wird dieses ToDo erzeugt',
  },
  {
    label: 'Verzögert',
    value: SCHEDULE_TYPE.DELAYED,
    tooltip:
      'Tritt das Triggerereignis ein, wird erst nach Ablauf der angegebenen Verzögerung das ToDo erzeugt',
  },
  {
    label: 'Intervall',
    value: SCHEDULE_TYPE.INTERVAL,
    tooltip:
      'Tritt das Triggerereignis ein, wird das ToDo nach dem angegebenen Intervall erzeugt',
  },
];

export const TODO_ACTIVITY_TYPE = {
  UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT',
  SHOW_USER_DETAILS: 'SHOW_USER_DETAILS',
  CONSULTATION: 'CONSULTATION',
  GENERAL_CONTACT: 'GENERAL_CONTACT',
  STORE_EMAIL: 'STORE_EMAIL',
  APTITUDE_TEST: 'APTITUDE_TEST',
  MARK_LEAD_AS_DONE: 'MARK_LEAD_AS_DONE',
  MARK_DOCUMENT_AS_PRESENT: 'MARK_DOCUMENT_AS_PRESENT',
  MAINTAIN_LEKS: 'MAINTAIN_LEKS',
  MAINTAIN_INVENTORY: 'MAINTAIN_INVENTORY',
  PRESENCE_LIST: 'PRESENCE_LIST',
  ABSENCE_LIST: 'ABSENCE_LIST',
  FEEDBACK: 'FEEDBACK',
} as const;

export const TODO_ACTIVITY_TYPES = [
  {
    label: 'Dokument hochladen',
    value: 'UPLOAD_DOCUMENT',
    img: '../../../assets/contract.png',
    tooltip:
      'Falls Sie nicht das korrekte Dokument hochladen, das Häkchen gesetzt wird und Sie nicht mehr korrigieren können, starten Sie bitte manuell die entsprechende Aktivität und setzen Sie den Status manuell.',
  },
  {
    label: 'Stammdaten anzeigen',
    value: 'SHOW_USER_DETAILS',
    img: '../../../assets/add-lead.png',
    tooltip:
      'Überprüfen oder Bearbeiten Sie die Stammdaten des betroffenen Leads oder Teilnehmers.',
  },
  {
    label: 'Beratungsgespräch',
    value: 'CONSULTATION',
    img: '../../../assets/Consultation.png',
    tooltip:
      'Erstellen Sie hier die entsprechende Aktivität. Ist das Häkchen gesetzt, ist schon eine Aktivität vorhanden, die Sie verändern können. Liegt ein Fehler vor, können Sie auch manuell die Aufgabe erledigen und den Status setzen.',
  },
  {
    label: 'Allgemeiner Kontakt',
    value: 'GENERAL_CONTACT',
    img: '../../../assets/Contact.png',
    tooltip:
      'Erstellen Sie hier die entsprechende Aktivität. Ist das Häkchen gesetzt, ist schon eine Aktivität vorhanden, die Sie verändern können. Liegt ein Fehler vor, können Sie auch manuell die Aufgabe erledigen und den Status setzen.',
  },
  {
    label: 'E-Mail ablegen',
    value: 'STORE_EMAIL',
    img: '../../../assets/email-icon.png',
    tooltip:
      'Erstellen Sie hier die entsprechende Aktivität. Ist das Häkchen gesetzt, ist schon eine Aktivität vorhanden, die Sie verändern können. Liegt ein Fehler vor, können Sie auch manuell die Aufgabe erledigen und den Status setzen.',
  },
  {
    label: 'Eignungstest durchführen',
    value: 'APTITUDE_TEST',
    img: '../../../assets/eignungstest.png',
    tooltip:
      'Mit der Aktivität können Einladungen UND Ergebnisse versendet werden. Ist das Häkchen gesetzt, ist schon eine Aktivität vorhanden, die Sie verändern können. Liegt ein Fehler vor, können Sie auch manuell die Aufgabe erledigen und den Status setzen.',
  },
  {
    label: 'Lead als Erledigt markieren',
    value: 'MARK_LEAD_AS_DONE',
    img: '../../../assets/Performance.png',
    tooltip:
      'Entfernen Sie in den Stammdaten des Leads den Haken bei "Ist aktiv?".',
  },
  {
    label: 'Dokument als Hochgeladen markieren',
    value: 'MARK_DOCUMENT_AS_PRESENT',
    img: '../../../assets/Performance.png',
    tooltip:
      'Diese Aktivität ist nicht implementiert. Laden Sie das Dokument hoch und setzen Sie den Status manuell.',
  },
  {
    label: 'LEK-Ergebnisse einpflegen',
    value: 'MAINTAIN_LEKS',
    img: '../../../assets/LEK.png',
    tooltip: 'Laden Sie die LEKS für diesen Kurs hoch.',
  },
  {
    label: 'Inventarliste aktualisieren',
    value: 'MAINTAIN_INVENTORY',
    img: '../../assets/Kursprogramm.png',
    tooltip: 'Aktualisieren Sie die Inventarliste.',
  },
  {
    label: 'Anwesenheit protokollieren',
    value: 'PRESENCE_LIST',
    img: '../../assets/anwesenheit.png',
    tooltip: 'Protokollieren Sie die Anwesenheit.',
  },
  {
    label: 'Fehlzeiten protokollieren',
    value: 'ABSENCE_LIST',
    img: '../../assets/Absent.png',
    tooltip: 'Protokollieren Sie die Fehlzeiten',
  },
  {
    label: 'Teilnehmerfeedback aufnehmen',
    value: 'FEEDBACK',
    img: '../../assets/Consultation.png',
    tooltip: 'Nehmen Sie Feedback der Kursteilnehmer auf',
  },
];

export type TodoStatus = (typeof TODO_STATUS)[keyof typeof TODO_STATUS];
export type EntityType = (typeof ENTITY_TYPE)[keyof typeof ENTITY_TYPE];
export type TriggerEvent = (typeof TRIGGER_EVENT)[keyof typeof TRIGGER_EVENT];
export type ScheduleType = (typeof SCHEDULE_TYPE)[keyof typeof SCHEDULE_TYPE];
export type CompletionEvent =
  (typeof COMPLETION_EVENT)[keyof typeof COMPLETION_EVENT];
export type TodoActivityType =
  (typeof TODO_ACTIVITY_TYPE)[keyof typeof TODO_ACTIVITY_TYPE];
